import { render } from "./StorageItemFilterWrapper.vue?vue&type=template&id=18c99d14&ts=true"
import script from "./StorageItemFilterWrapper.vue?vue&type=script&lang=ts"
export * from "./StorageItemFilterWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
